// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"213":"1708a075","239":"aa489265","455":"27ffdd58"}[chunkId] + ".chunk.js";
};